export function Switch({
  id,
  checked,
  onChange,
  title,
  description,
}: {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  title: string;
  description: string;
}) {
  return (
    <label className="switch-row" htmlFor={id}>
      <input
        type="checkbox"
        role="switch"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="switch-hidden-input"
      />
      <span className="switch-track" data-on={checked} aria-hidden="true">
        <span className="switch-knob" />
      </span>
      <span className="switch-copy">
        <span className="switch-title">{title}</span>
        <span className="switch-desc">{description}</span>
      </span>
    </label>
  );
}
